import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserDataService } from '../../../core/services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class CrossSellingGuard {
  constructor(
    private userDataService: UserDataService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.userDataService.company?.serviceAddons.includes(route.params['addon'])) {
      this.router.navigateByUrl('/secured/home');
      return false;
    }

    return true;
  }
}
